/* eslint-disable import/no-anonymous-default-export */
import colors from "./colors";
import Form from "./form";
import Card from "./card";
import Button from "./button";
import Text from "./text";
import styles from "./styles";

export default {
  fonts: {
    body: `'Poppins', sans-serif`,
    heading: `'Poppins', sans-serif`,
    label: `'Poppins', sans-serif`,
  },
  colors,
  components: {
    Text,
    Card,
    Button,
    Form,
  },
  styles,
};
